import { HttpClient } from '@angular/common/http';

import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { DbService } from 'src/app/services/db/db.service';
import { FichaTecnicaComponent } from '../ficha-tecnica/ficha-tecnica.component';

@Component({
  selector: 'app-player-sesion',
  templateUrl: './player-sesion.component.html',
  styleUrls: ['./player-sesion.component.scss'],
})
export class PlayerSesionComponent implements OnInit, AfterViewInit {

  play = false;
  sesion;
  fichaInfo;
  videosArray = [] ;
  currentIndexVideo = 0;
  @ViewChild('videoE',{read:ElementRef})videoE: ElementRef;

  constructor(private modalController: ModalController, private route: ActivatedRoute,private router: Router, private dbService: DbService) {
    this.route.params.subscribe(params => {
      this.sesion = params.id;
      this.dbService.getFichaTecnica(params).then(fichaRes => {
        this.fichaInfo = fichaRes;
      })

      this.dbService.getVideosSesion(params).then((videosRes:any) => {
        this.videosArray = videosRes;
      })

    })
  }

  ngOnInit() {
  }
  ngAfterViewInit(){
  }

  navPrevPage(){
  this.router.navigateByUrl('/herir')
  }

  playPause() {
    if(this.play){
      this.videoE.nativeElement.pause();
      this.play = false;
    }else{
      this.videoE.nativeElement.play();
      this.play = true;
    }
    
  }

  paused($event){
    this.play = false
  }
  resume(){
    this.play = true
  }
  nextVideo(){
    this.currentIndexVideo ++;
    this.play = false
    setTimeout(() => {
      this.playPause()
    }, 1500);
  }
  prevVideo(){
    this.currentIndexVideo --;
    this.play = false
    setTimeout(() => {
      this.playPause()
    }, 1500);
  }
  async presentModal() {
    const modal = await this.modalController.create({
      component: FichaTecnicaComponent,
      componentProps: { dataF: this.fichaInfo,sesion: this.sesion },
      cssClass: "modalc",
      backdropDismiss: true
    });

    await modal.present();

  }


}
